const lbaSpacer = angular.module('app.lbaSpacer', []);

lbaSpacer.directive('lbaSpacer', require('./lbaSpacerDir'));

export default lbaSpacer;



// WEBPACK FOOTER //
// ./src/components/lbaSpacer/index.js